import '../../styles/EventsStyles/PrototypeNotice.css';
import { IS_PROTOTYPE } from '../../webinars/config';

interface PrototypeNoticeProps {
  variant: "public" | "admin";
}

// The prototype keeps data in this browser and never emails anyone: say so plainly on every
// screen. The production build (Supabase) shows nothing here.
export default function PrototypeNotice({ variant }: PrototypeNoticeProps) {
  if (!IS_PROTOTYPE) return null;
  return (
    <div className="km-prototype-notice" role="note">
      <div className="km-container">
        <strong>Prototype for review.</strong>{" "}
        {variant === "public"
          ? "Registrations are saved only in this browser on this device, are not sent to Kole Medical, and no emails are sent. Please don't enter real personal information."
          : "No sign-in, and only data saved in this browser. Emails are simulated: nothing is sent. The live version uses administrator sign-in and the central database."}
      </div>
    </div>
  );
}
